import React from 'react'

import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import ExternalLink from '@components/shared/ExternalLink'
import { ScoreEvent } from '@custom-types/activity'
import { buildAvatarUrl } from '@models/util/user.util'
import { formatRelativeTime } from '@utils/formatters/date.formatter'
import PageRoutes from '@utils/page-routes'

interface Props {
  event: ScoreEvent
}

const ScoreActivity: React.FC<Props> = ({ event }: Props) => {
  const { t } = useTranslation()
  const { action, actionTarget, actor, actionDetails } = event
  return (
    <div className="ml-3 flex-1 flex flex-row items-center">
      <span className="flex-1 break-words">
        <ExternalLink
          className="underline-link mr-1"
          href={PageRoutes.userProfilePath(actor.external_id)}>
          {actor.username}
        </ExternalLink>
        {t(`event.${action}`)}
        <ExternalLink
          className={classNames(
            'underline-link',
            ['sharedScoreWithUser', 'sharedScoreWithYou'].includes(action) ? 'mx-1' : 'ml-1'
          )}
          href={PageRoutes.editorPath(actionTarget.external_id)}>
          {actionTarget.title}
        </ExternalLink>
        {action === 'sharedScoreWithUser' && (
          <>
            {t('event.with')}
            <ExternalLink
              className="underline-link mr-1 flex flex-row items-center"
              href={PageRoutes.userProfilePath(actionDetails.external_id)}>
              <div className="w-[20px] h-[20px] inline-block mx-1">
                <img src={buildAvatarUrl(actionDetails)} alt={actionDetails.username} />
              </div>
              {actionDetails.username}
            </ExternalLink>
          </>
        )}
        {action === 'sharedScoreWithYou' && t('event.withYou')}
        {'.'}
      </span>
      <span className="text-gray-text dark:text-gray-text-dm pl-2.5 text-xs whitespace-nowrap">
        {formatRelativeTime(event.when, new Date())}
      </span>
    </div>
  )
}

export default ScoreActivity
